<div class="partner-login-container">

  <div class="login-box">
    <div class="logo-container">
      <img src="assets/imgs/FINAL_Pasture_Por_ by_Ag_Innovations_logo.png" alt="AG Innovations">
    </div>

    <h1 class="login-header">Login</h1>

    <form [formGroup]="form" (ngSubmit)="submitLogin(form.value)" class="login-form">
      <mat-form-field appearance="standard">
        <mat-label>Username</mat-label>
        <input matInput type="text" formControlName="userName">
      </mat-form-field>

      <mat-form-field appearance="standard">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password">
      </mat-form-field>

      <div class="button-container">
        <button type="submit" mat-raised-button class="custom-login-btn">Login</button>
      </div>
    </form>
  </div>

</div>
